module.exports = require("/vercel/path0/web/.gatsby/gatsby-browser.tsx");